import styled from 'styled-components'

const Value = styled.span`
  font-size: 14px;
  margin-right: 5px;
`

export default Value
